import React from "react";
import "antd/dist/antd.css";
import DashBoardMobileServices from "../../DashBoard/DashBoardMobile/DashBoardMobileServices";
import { useTripsCtx } from "../../../context/TripDetailsContext";

interface Props {
  personId: string;
  parentPersonId: number;
  typeOfService: string;
  serviceUserName: string;
}

const ServiceUsersMobile: React.FC<Props> = ({
  personId,
  parentPersonId,
  typeOfService,
  serviceUserName,
}) => {
  const {
    upcomingTripDetailsCtx,
    pastTripDetailsCtx,
    favoriteTripDetailsCtx,
  } = useTripsCtx();
  const [upcomingTripDetails] = upcomingTripDetailsCtx;
  const [pastTripDetails] = pastTripDetailsCtx;
  const [favoriteTripDetails] = favoriteTripDetailsCtx;

  return (
    <>
      <DashBoardMobileServices
        serviceType={typeOfService}
        serviceUserId={personId}
        upcomingTripDetails={upcomingTripDetails}
        pastTripDetails={pastTripDetails}
        favoriteTripDetails={favoriteTripDetails}
        serviceUserName={serviceUserName}
        isCalling="serviceUsersMobile"
      />
    </>
  );
};

export default ServiceUsersMobile;
